var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`lds-ring ${_vm.size}`},[_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }